<template>
  <div id="users" class="users">
    <div
      :id="'users_' + type"
      style="overflow-y: auto"
      v-resize="onResizeUserList"
      :style="{ height: userListHeight + 'px' }"
      @scroll="onUserScroll"
    >
      <div :id="'users_' + type + '_container'">
        <v-layout justify-center column fill-height v-if="userloading || usersearching">
          <div class="text-xs-center mt-4 mb-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-layout>
        <template v-else-if="livechatUsers(type) && livechatUsers(type).length > 0">
          <div
            v-for="(user, index) in sortedUsers"
            :key="'user-' + index + '-' + user.userid"
            @click="selectUser(user)"
            class="user"
          >
            <user-item
              v-model="livechatUsers(type)[index]"
              :selected="selectedUser != null && user.userid == selectedUser.userid"
              :key="livechatUsers(type)[index].userid"
            ></user-item>
            <v-divider></v-divider>
          </div>
          <!-- <div
            v-if="loadmore"
            class="text-xs-center"
            style="background:#eee;padding-top:10px;padding-bottom:10px"
          >
            <v-progress-circular indeterminate color="grey" small class="mr-2" :width="2"></v-progress-circular>Loading
          </div>-->
          <template v-if="isMobile">
            <div
              class="text-xs-center"
              style="background: #eee; padding-top: 10px; padding-bottom: 10px"
              @click="onLoadmore"
            >
              <template v-if="loadmore">
                <v-progress-circular
                  indeterminate
                  color="grey"
                  small
                  class="mr-2"
                  :width="2"
                ></v-progress-circular
                >Loading
              </template>
              <template v-else @click="onLoadmore">Click to load more conversation</template>
            </div>
          </template>
          <template v-else>
            <div
              v-if="loadmore"
              class="text-xs-center"
              style="background: #eee; padding-top: 10px; padding-bottom: 10px"
            >
              <v-progress-circular
                indeterminate
                color="grey"
                small
                class="mr-2"
                :width="2"
              ></v-progress-circular
              >Loading
            </div>
          </template>
        </template>
        <v-layout justify-center column fill-height v-else>
          <div class="text-xs-center mt-4 mb-4">
            <img src="/static/img/assets/livechat/no_user.png" alt />
            <div>No users</div>
          </div>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userItem from './livechat-user-item'
import api from '@/api'

export default {
  props: ['value', 'type', 'app', 'filter', 'isMobile', 'usersearching'],
  data: function () {
    return {
      loading: true,
      userloading: true,
      maxTime: 15000,
      timer: '',
      windowHeight: 0,
      userListHeight: 0,
      limit: 20,
      offset: 0,
      users: [],
      isAutoRefresh: true,
      loadmore: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      livechatUsers: 'getLivechatUsers',
      selectedUser: 'getCurrentUser',
    }),
    sortedUsers: function () {
      var vm = this
      var users = []
      users = vm.livechatUsers(vm.type).sort(function (a, b) {
        return new Date(b.lastreply_time) - new Date(a.lastreply_time)
      })
      return users
    },
  },
  components: {
    'user-item': userItem,
  },
  created: function () {
    let vm = this

    vm.timer = setInterval(() => {
      vm.$store.dispatch('loadLatestUsers', {
        type: vm.type,
      })
    }, vm.$store.state.livechat.maxFatchUserTime)
  },
  mounted: async function () {
    let vm = this
    vm.userloading = true
    try {
      vm.$set(vm.$store.state.livechat, 'app', vm.app)
      await vm.$store.dispatch('loadLatestUsers', {
        type: vm.type,
      })
      vm.userloading = false
      vm.onResizeUserList()
    } catch (error) {
      vm.userloading = false
      vm.$swal.fire({
        title: 'Load failed',
        // title: error,
        type: 'error',
        confirmButtonText: vm.$t('Confirm'),
      })
    }
  },
  methods: {
    onUserScroll: async function () {
      var vm = this
      if (vm.isMobile) {
        return false
      }
      let messages = $('#users_' + vm.type)
      let scrollPosition = messages.scrollTop()
      let chatboxHeight = messages.outerHeight(true)
      let totalHeight = messages.prop('scrollHeight')

      if (scrollPosition <= chatboxHeight) {
        vm.enableAutoUpdate(true)
      }
      if (Math.abs(Math.round(scrollPosition + chatboxHeight) - totalHeight) < 3) {
        vm.enableAutoUpdate(false)
        await vm.onLoadmore()
      }
    },
    enableAutoUpdate: function (enable) {
      this.$set(this.$store.state.livechat.userlist[this.type], 'isAutoRefresh', enable)
    },
    onResizeUserList: function () {
      var vm = this
      vm.$nextTick(function () {
        if (document.getElementById('chattype')) {
          vm.userListHeight =
            window.innerHeight -
            document.getElementById('main_toolbar').clientHeight -
            document.getElementById('chattype').clientHeight -
            5
        }
      })
    },
    selectUser: async function (user) {
      if (!this.selectedUser || this.selectedUser.userid != user.userid) {
        user.type = this.type
        this.$set(this.$store.state.livechat, 'currentUser', user)
        this.$emit('input', user)
        this.$emit('onClickUser')
        if (['toa'].includes(this.selectedBot.theme)) {
          var res = await api.adminreadchat(
            {
              adminid: this.$store.state.userid,
              userid: user.userid,
            },
            () => {}
          )
          var vm = this
          vm.$nextTick(() => {
            this.selectedUser.adminread = true
            vm.$forceUpdate()
          })
        }
      }
    },
    getLatestChatUsers: function () {
      var vm = this
      if (vm.loading) {
        return false
      }
      let limit = 20
      if (vm.livechatUsers(vm.type).length == 0) {
        limit = 20
      }

      vm.getLiveChatUsers(0, limit, true).then(
        function (users) {
          vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: users })
        },
        function (error) {
          // console.log(error)
        }
      )
    },
    getLiveChatUsers: function (offset, limit, latest) {
      let vm = this
      return new Promise((resolve, reject) => {
        vm.loading = true
        let data = {
          pageid: vm.selectedBot.pageid,
          offset: offset,
          limit: limit,
          inbox: vm.type,
          app: vm.app,
        }
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            data.uu_areaname = vm.selectedBot.uu_areaname
          } else if (vm.filter.uuAreaName != '') {
            data.uu_areaname = vm.filter.uuAreaName
          }
          if (vm.filter.lineid) {
            data.lineid = vm.filter.lineid
          }
          if (vm.filter.uu_register_status) {
            data.uu_register_status = vm.filter.uu_register_status
          }
          if (vm.filter.lastconversationfrom) {
            data.lastconversationfrom = vm.filter.lastconversationfrom
          }
          if (vm.filter.lastconversationto) {
            data.lastconversationto = vm.filter.lastconversationto
          }
        }
        api.getLiveChatUsers(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.loading = false
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
    matchChatboxHeight: function () {
      let vm = this
      let totalHeight = vm.windowHeight
      let headerHeight = $('header').outerHeight(true)
      let typeHeight = $('#chattype').outerHeight(true)
      totalHeight = totalHeight - headerHeight - typeHeight
      $('.users').height(totalHeight)
    },
    onLoadmore: async function () {
      var vm = this
      if (vm.loadmore || !vm.$store.state.livechat.userlist[vm.type].hasMore) {
        return false
      }
      vm.loadmore = true

      vm.$set(
        vm.$store.state.livechat.userlist[vm.type],
        'limit',
        vm.$store.state.livechat.userlist[vm.type].limit + vm.$store.state.livechat.limitFatchUser
      )

      try {
        await vm.$store.dispatch('loadLivechatUsers', {
          type: vm.type,
        })
        vm.loadmore = false
      } catch (error) {}
    },
  },
  watch: {
    type: async function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type,
          })
          vm.userloading = false
        } catch (error) {}
      }
    },
    app: async function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$set(vm.$store.state.livechat, 'app', newVal)
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type,
          })
          vm.userloading = false
        } catch (error) {}
      }
    },
    selectedBot: async function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type,
          })
          vm.userloading = false
        } catch (error) {}
      }
    },
    // filter: {
    //   handler: async function(newVal, oldVal) {
    //     let vm = this
    //     if (newVal != oldVal) {
    //       vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
    //       vm.userloading = true
    //       try {
    //         await vm.$store.dispatch('loadLivechatUsers', {
    //           type: vm.type
    //         })
    //         vm.userloading = false
    //       } catch (error) {}
    //     }
    //   },
    //   deep: true
    // },
    value: function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.selectedUser = newVal
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
.user {
  cursor: pointer;
  &:hover {
    background: #eee;
  }

  &:active {
    background: rgb(245, 244, 244);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-users.vue